
import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'
const _ = require('lodash')

let initStore = {
    loading: false,
    error: false,
    my_data_svtoc:{
        "id": "addLeft_step",
        "testlastName": "svlondonKW",
        "dateOfBirth": "6000-01-15",
        "members": [
            {
                "tid": 1,
                "dateOfBirth": "1982-01-15",
                "gender": "MALE",
                "firstName": "svkap",
                "lastName": "sval",
                "emailAddress": "svr@yahoo.com",
                "memphones": [
                    {
                        "deviceType": "MOBILE",
                        "countryCallingCode": "34",
                        "number": "480080085"
                    }
                ],
                "members": [
                    {
                        "documentType": "IDENTITY_CARD",
                        "birthPlace": "Sanfrancisco",
                        "issuanceLocation": "Sanfrancisco",
                        "issuanceDate": "2015-04-13",
                        "documentNumber": "00000069",
                        "expiryDate": "2025-04-13",
                        "issuanceCountry": "US",
                        "validityCountry": "US",
                        "nationality": "US",
                        "holder": "Y"
                    }
                ],
                "id": "addLeft_STEP",
                "gene": "addLeft_STEP",
                "clubName": "Soccer"
            },
            {
                "tid": 2,
                "dateOfBirth": "1982-01-15",
                "gender": "MALE",
                "firstName": "Seteve",
                "lastName": "Borrow",
                "emailAddress": "steve@yahoo.com",
                "memphones": [
                    {
                        "deviceType": "MOBILE",
                        "countryCallingCode": "1",
                        "number": "480080081"
                    }
                ],
                "members": [
                    {
                        "documentType": "IDENTITY_CARD",
                        "birthPlace": "Sanfrancisco",
                        "issuanceLocation": "Sanfrancisco",
                        "issuanceDate": "2015-04-13",
                        "documentNumber": "00000069",
                        "expiryDate": "2025-04-13",
                        "issuanceCountry": "US",
                        "validityCountry": "US",
                        "nationality": "US",
                        "holder": "Y"
                    }
                ],
                "id": "addLeft_STEP1",
                "gene": "addLeft_STEP1",
                "clubName": "SVCriuseBALL"
            }
        ],
           "gender": "MALE"
    },
    /*sva*/
    marerrob :{
        "hasErrors": false,
        "error": "Toc Page Validation Error",
        "message": "Min 2 Travellers and Max 5 GTravellers for 1 cabin booking",
        "field":"Travellers"
    },
    errob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    crudsuccessob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 200,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    /*svae */
    my_data: [],
    loadingRESERVATION:false,
    errorRESERVATION:false,
    my_data_traveller:{
        "id": "addLeft_step",
        "gene": "addLeft_step",
        "dcountry": "China",
        "privateparking":false,
        "rentcar":false,
        "bookTaxi":false,
        "needFlight":false,
        "arrivalTimeZone":"tz_pst",
        "fname": "John",
        "lname": "Glen",
        "email": "john123@yahoo.com",
        "address": "Glen",
        "city": "Glen",
        "state": "Glen",
        "zip": "12110",
        "country": "Glen",
        "isdcode": "+1",
        "phone": "Glen",
        "bookingAgentType": "self",
        "traveType": "Personal",
        "specialRequests": "Wheel chair and Senior Citizen",
        "gname": "Glen",
        "gemail": "Glen@yahoo.com",
        "card": "1234-1234--1234--1234",
        "cvv": "Glen",
        "mmexp": "04",
        "yyyyexp": "2028"
    },
    custProfile: {
        "customerId": -2,
        "addressId":-1
    },
    my_data_geo:{
        "countryTypes": [
            {
                "name": "United STates America",
                "a2": "US",
                "a3": "USA",
                "value": "USA",
                "isonum": "840"
            },
            {
                "name": "Canada",
                "isdcode": "01",
                "a2": "CA",
                "a3": "CAN",
                "value": "CAN",
                "isonum": "124"
            }
        ],
        "stateTypes": [
            {
                "name": "California",
                "value": "CA",
                "a2": "CA"
            },
            {
                "name": "New York",
                "value": "NY",
                "a2": "NY"
            },
            {
                "name": "Texas",
                "value": "TX",
                "a2": "TX"
            }
        ],
        "isdcodeTypes": [
            {
                "name": "United States Of America(+1)",
                "value": "1"
            },
            {
                "name": "Australia(+61)",
                "value": "61"
            },
            {
                "name": "Spain(+34)",
                "value": "34"
            }
        ],
        "genderTypes": [
            {
                "name": "CL_MALE",
                "value": "MALE"
            },
            {
                "name": "CL_FEMALE",
                "value": "FEMALE"
            }
        ]
    },
    cr_data_dtoken:{
        "email": "suelb22@yahoo.com",
        "subject": "Reservation Details",
        "customerId": "-131",
        "status": "OK",
        "digitalCode": "111111"
    },
    cr_data_card:{
        "id": "-4",
        "cardId": "-4",
    
       
        "card": "7777-1234--1234--1234",
        "cvv": "777",
        "mmexp": "07",
        "yyyyexp": "77",
        "otherDetails" :"Default facility",
        "specialRequests": "Default chair and Senior Citizen",
        "privateparking":false,
            "rentcar":false,
            "bookTaxi":false,
            "needFlight":false,
            "arrivalTimeZone":"tz_pst"
      
        
    
      },

    cr_data_address: {
        "id": 6,
        "addressId": 6,
        "customerId": 6,
        "name": "alen beta",
        "fname": "alen",
        "lname": "beta",
        "phone": "5121231234",
        "email": "alen11@br.com",
        "login": "alenb",
        "password": null,
        "otherDetails": "need pickup",
        "city": "san jose",
        "state": "ca",
        "country": "usa",
        "address": null,
        "zip": "95123",
        "zipcode": "95123",
        "isdcode": "1",
        "addressType": "B",
        "createdDate": null,
        "modifiedDate": null,
        "createdBy": null,
        "modifiedBy": null
    },
    my_data_crreview:{
        "Request": {
            "checkin": "OK",
            "stay": "6",
            "stayInit": "nights",
            "checkout": "UU12345",
            "checkinTime": "Sat, Sept 9, 3027",
            "checkinTimePrefix": "From 3:00 PM",
            "checkoutTimePrefix": "Until 11:00 AM",
            "checkoutTime": "Sat, Sept 16, 3027"
        },
        "spaceDet": {
        
            "space_details": "Queen Room with Two Queen Beds",
            "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
            "cancellation": "Free cancellation before December 9, 2024 ",
            "guests": "2 adults ",
            "cleaniness_score" : "7.7",
            "non_smoking":true,
    
            "space_amenity_name": [
                "300 feet elevator",
                "air conditioning",
                "private bathroom"
            ]
           
           
        },
        "booking": {
            "resort_name": "Cambria Hotel Orlando Airport",
            "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
            "stayDet": "6 nights",
            "num_reviews": 101,
            "amenity_name": [
                "HotTub",
                "Spa",
                "Swimming pool",
                "Laundry"
            ],
            "num_reviews_label": "Good, ",
            "rating_detail":" Excellebt, 9.1",
            "num_reviews_detail": "Good, 101 reviews"
           
        },
        "price": {
            "total": "$923",
            "depositValue":"$200.26",
            "depositName":"Damage Deposit (Fully refundable)",
            "currency": "usd",
            "tax": {
               
                "taxTotal": "$102.34",
                "maintax": "$49.08",
                "citytax": "$53.26",
    
                "taxPercent": "6",
                "citytaxPercent": "6.5"
            }
        },
        "id": "addLeft_step",
        "gene": "addLeft_step",
        "dcountry": "China",
        "privateparking":false,
        "rentcar":false,
        "bookTaxi":false,
        "needFlight":false,
        "arrivalTimeZone":"tz_pst",
        "fname": "John",
        "lname": "Glen",
        "email": "john123@yahoo.com",
        "address": "Glen",
        "city": "Glen",
        "state": "Glen",
        "zip": "12110",
        "country": "Glen",
        "isdcode": "+1",
        "phone": "Glen",
        "bookingAgentType": "self",
        "traveType": "Personal",
        "specialRequests": "Wheel chair and Senior Citizen",
        "gname": "Glen",
        "gemail": "Glen@yahoo.com",
        "card": "1234-1234--1234--1234",
        "cvv": "Glen",
        "mmexp": "04",
        "yyyyexp": "2028"
    },
    my_data_price_cr_confirmation:{

        "status":"OK",
        "confirmationNumber":"UU12345",
        "chekinDate":"Jan 3027"
    },
    svr_cr_detail_images_ob:{
        "images":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj7.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj8.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj9.jpg`],
        "gallery":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg` ],
        "arcade":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`],
        "face":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`]
    
    },
    
    cruises:[]
    
}

export default (state = initStore, action) => {
    console.log(action);
    let januState, svns;
    switch (action.type) {
        case "book/LIST_SOJOURNS":

     console.log('tasks LIST_SOJOURNS reducer')
     
    
      console.log(svns)
      if(Array.isArray(action.cruises) && (action.cruises.length >0)){
       
        state.cruises =_.clone(action.cruises)
      }
     svns = Object.assign({}, state, {cruises:action.cruises})
      console.log('sv reduce --for LIST_TASKS')
      console.log(svns)

      return svns
        case 'GET_CRPRICEANDTAX_SUCCESS':
            console.log("reduce %%%%%%%%GET_CRPRICEANDTAX_SUCCESS  success*****************");
            console.log(action.payload.my_data_price_cr_confirmation);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            /*sva
            
            januState = {...state, loadingRESERVATION: false, my_data_price_cr_confirmation: action.payload.my_data_price_cr_confirmation}
            */
            januState = {...state, loadingRESERVATION: false,errorRESERVATION: false, errob:null,crudsuccessob:null, my_data_price_cr_confirmation: action.payload.my_data_price_cr_confirmation}
            
            return januState

        case 'GET_CRPRICEANDTAX_BEGIN':
            console.log("loading")
            return {...state, loadingRESERVATION: true}
        case 'GET_CRPRICEANDTAX_ERROR':
            console.log("error")
            return {...state, errorRESERVATION: true, errob:action.payload.errob,crudsuccessob:null}

        /*sva */
        case "RESET_CRPRICEANDTAX_INIT":
            let  my_data_price_cr_confirmation_init = {
                "id":-11,
                "status":"FAILED",
                "confirmationNumber":"",
                "chekinDate":""
            }
             console.log("reduce %%%%%%%%RESET_SAVESTOREDCARD_INIT  success*****************");
                januState = {...state, errorRESERVATION:false, loadingRESERVATION:false, crudsuccessob:null, my_data_price_cr_confirmation:my_data_price_cr_confirmation_init}
 
        /*svae */
        /*svay21 start */
        case 'GET_CRREVIEW_MAILUSER_SJ_SUCCESS':
            console.log("reduce %%%%%%%%GET_CRREVIEW_MAILUSER_SJ_SUCCESS  success*****************");
            console.log(action.payload.my_data_crreview);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            januState = {...state, loadingRESERVATION: false, cr_data_address:action.payload.cr_data_address}
            return januState
        /*svmay21 end */
        case 'GET_CRREVIEW_SUCCESS':
            console.log("reduce %%%%%%%%GET_CRREVIEW_SUCCESS  success*****************");
            console.log(action.payload.my_data_crreview);
            //svjun4 start
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
            //januState = {...state, loadingRESERVATION: false, my_data_crreview: action.payload.my_data_crreview}
          
            januState = {...state, loadingRESERVATION: false, my_data_geo:action.payload.my_data_geo, my_data_crreview: action.payload.my_data_crreview}
            //svjun4 end
            return januState
        case 'CRRESERVATIONS_PRIMARY_ADDRESS':
                console.log("reduce %%%%%%%%GET_CRREVIEW_SUCCESS  success*****************");
                console.log(action.payload.cr_data_address);
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                januState = {...state,  cr_data_address: action.payload.cr_data_address}
                return januState
        case 'CRRESERVATIONS_PRIMARY_CONFIRMATION':
                console.log("reduce %%%%%%%%CRRESERVATIONS_PRIMARY_CONFIRMATION  success*****************");
                console.log(action.payload.my_data_price_cr_confirmation);
                    // let januState = {...state, loading: false, my_data: action.payload.my_data}
                januState = {...state,  my_data_price_cr_confirmation: action.payload.my_data_price_cr_confirmation}
                return januState
        
        case 'CRRESERVATIONS_PRIMARY_SVTOC':
                console.log("Mar22 Gort action crLoadsvtocData reduce Nov3 %%%%%%%%FLYMYRESERVATIONS_PRIMARY_SVDOC  success*****************");
                console.log(action.payload.my_data_svtoc);
                            // let januState = {...state, loading: false, my_data: action.payload.my_data}
                januState = {...state,  my_data_svtoc: action.payload.my_data_svtoc}
                return januState

        case 'GET_CRREVIEW_MYRESERVATION_SV_SUCCESS':
                console.log("reduce %%%%%%%%GET_CRREVIEW_MYRESERVATION_SV_SUCCESS  success*****************");
                console.log(action.payload);

                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                januState = {...state, errob:null,crudsuccessob:null,loadingRESERVATION: false,cr_data_card:action.payload.cr_data_card, cr_data_address: action.payload.cr_data_address,custProfile:action.payload.custProfile, my_data_crreview: action.payload.my_data_crreview}
                return januState
        case 'GET_CRREVIEW_BEGIN':
                console.log("loading")
                return {...state, loadingRESERVATION: true}
        case 'GET_CRREVIEW_ERROR':
                console.log("error")
                return {...state, errorRESERVATION: true}
        case 'SAVETRAVELLER_CRREVIEW_SUCCESS':
                    console.log("reduce %%%%%%%%SAVETRAVELLER_CRREVIEW_SUCCESS   success*****************");
                    console.log(action.payload.my_data_traveller);
                    // let januState = {...state, loading: false, my_data: action.payload.my_data}
                    januState = {...state,  my_data_traveller: action.payload.my_data_traveller}
                    return januState
        /*svarp13 start */
        case 'SAVETOCUMENT_CRREVIEW_SUCCESS':
                    console.log("reduce %%%%%%%% NOV-11****SAVETOCUMENT_CRREVIEW_SUCCESS   success*****************");
                    console.log(action.payload.my_data_svtoc);
                    const {marerrob} = action.payload
                    if(marerrob ){
                        januState = {...state,  my_data_svtoc: action.payload.my_data_svtoc, marerrob:action.payload.marerrob}
                    }else{
                        januState = {...state,  my_data_svtoc: action.payload.my_data_svtoc}
                    }
                        // let januState = {...state, loading: false, my_data: action.payload.my_data}
                    
                    return januState
         /*svapr15 start*/
         case 'SAVEMARINERTOC_CRREVIEW_ERROR':
            console.log("reduce %%%%%%%% APR-15****SAVEMARINERTOC_CRREVIEW_ERROR   success*****************");
            console.log(action.payload.marerrob);
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
            januState = {...state,  marerrob: action.payload.marerrob}
            return januState

        /*svapr15 end */
        case 'SAVEDOCUMENT_CRREVIEW_SUCCESS':
                    console.log("reduce %%%%%%%% NOV-5****8SAVEDOCUMENT_CRREVIEW_SUCCESS   success*****************");
                    console.log(action.payload.my_data_svdoc);
                    // let januState = {...state, loading: false, my_data: action.payload.my_data}
                    januState = {...state,  my_data_svdoc: action.payload.my_data_svdoc}
                    return januState
            
        /*svapr13 end */
       
        
        default:
            return state
    }
}